import {Button, Modal, Spinner} from 'react-bootstrap'
import {FormattedMessage, defineMessages, useIntl} from 'react-intl'
import {CHANGE_STATE_LEAD} from '../../../gql/mutations/leadMutations'
import {IResChangeState} from '../../leads/leadTypes'
import {useMutation} from '@apollo/client'
import {useEffect} from 'react'
import {toast} from 'react-toastify'
import {parseId} from '../../../helpers'

const quote = '"'

const cM = defineMessages({
  title: {id: 'leads.changeStage.title', defaultMessage: 'Change stage'},
  willChange: {id: 'leads.changeStage.willChange', defaultMessage: 'This action will change the lead to the <b>{name}</b> stage'},
  confirm: {id: 'leads.changeStage.confirm', defaultMessage: 'Are you sure you want to change the stage of this lead?'},
  toastSuccess: {id: 'leads.changeStage.toast.success', defaultMessage: 'Lead has changed state successfully'},
})

export const ModalChangeStateWizard: React.FC<{
  info: {id: string; name: string}
  refetch: () => void
  onClose: () => void
  isOpen: boolean
  leadId: string
}> = ({info, isOpen, onClose, refetch, leadId}) => {
  const intl = useIntl()
  const errMsg = (message?: string) =>
    intl.formatMessage({id: 'common.error.withMessage', defaultMessage: 'Error: {message}'}, {message})

  const [gqlChange, {data: dataChange, loading: loadingChange, error: errorChange}] =
    useMutation<IResChangeState>(CHANGE_STATE_LEAD)

  useEffect(() => {
    if (errorChange) {
      toast.error(errMsg(errorChange.message))
    }
  }, [errorChange])

  useEffect(() => {
    if (!dataChange) return
    if (dataChange.changeLeadStage.success) {
      toast.success(intl.formatMessage(cM.toastSuccess))
      refetch()
      onClose()
    } else if (dataChange.changeLeadStage.errors && dataChange.changeLeadStage.errors.length > 0) {
      toast.error(errMsg(dataChange.changeLeadStage.errors[0].message))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataChange])

  const handleChangeStage = () => {
    gqlChange({
      variables: {
        leadId: leadId,
        stageId: parseId(info.id),
      },
    })
  }

  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{intl.formatMessage(cM.title)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6 className='text-center'>
          {intl.formatMessage(cM.willChange, {name: info.name, b: (chunks: (string | JSX.Element)[]) => <span className='text-danger'>{quote}{chunks}{quote}</span>})}
        </h6>
        <h2 className='text-center'>{intl.formatMessage(cM.confirm)}</h2>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          <FormattedMessage id='common.action.close' defaultMessage='Close' />
        </Button>
        <Button variant='primary' onClick={handleChangeStage} disabled={loadingChange}>
          {loadingChange && <Spinner animation='border' size='sm' />}
          <FormattedMessage id='common.action.saveChanges' defaultMessage='Save changes' />
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
